import state from './suppliesState'
import mutations from './suppliesMutations'
import actions from './suppliesActions'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
}
